import React from 'react';
import { DashboardStats } from '../../hooks/useDashboardData';

interface DashboardStatsProps {
  stats: DashboardStats;
}

const DashboardStatsComponent: React.FC<DashboardStatsProps> = React.memo(({ stats }) => {
  return (
    <div className="overview-stats" role="region" aria-label="Key Performance Metrics">
      <div className="stat-card" role="img" aria-label={`Total customers: ${stats.total}`}>
        <div className="stat-value" aria-hidden="true">{stats.total}</div>
        <div className="stat-label">Total Customers</div>
      </div>
      <div className="stat-card" role="img" aria-label={`Completed onboarding: ${stats.completed} customers`}>
        <div className="stat-value" aria-hidden="true">{stats.completed}</div>
        <div className="stat-label">Completed</div>
      </div>
      <div className="stat-card" role="img" aria-label={`At risk customers: ${stats.atRisk}`}>
        <div className="stat-value" aria-hidden="true">{stats.atRisk}</div>
        <div className="stat-label">At Risk</div>
      </div>
      <div className="stat-card" role="img" aria-label={`Average progress: ${stats.avgProgress} percent`}>
        <div className="stat-value" aria-hidden="true">{stats.avgProgress}%</div>
        <div className="stat-label">Avg Progress</div>
      </div>
    </div>
  );
});

DashboardStatsComponent.displayName = 'DashboardStats';

export default DashboardStatsComponent;